import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { Instances } from '../../../../../constants';
import { closeModal } from '../../../../../store/modals';
import { IStateType } from '../../../../../store/models/root.interface';
import { requestObject } from '../../../../../store/Object';
import { requestObjects } from '../../../../../store/Objects';

import PublishConfiguration, { DispatchPropsType, BaseSeeMorePropsType } from '../../organisms/receiveMessage/publishConfiguration';

const mapStateToProps = (state: IStateType) => ({
    visible: state.modals.isOpen,
    id: state.modals.params,
    keyword: state.modals.params?.extraParams,
    number_type: state.modals.params?.extraParams?.number_type
})

const mapDispatchToProps = (dispatch: any) => ({
    onClose: () => dispatch(closeModal()),
    onUpdatePublishStatus: (formData: any, callback: (resp: any, flag: boolean) => void) => dispatch(requestObject(Instances.vmnSavePublishStatus, undefined, undefined, 'post', true, true, formData, (response: any, flag: boolean) => callback(response, flag))),
    onLoad: () => dispatch(requestObjects(Instances.vmnConfigurationListing))
})

export default connect<BaseSeeMorePropsType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(PublishConfiguration));
